import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'c-page-title',
  templateUrl: './page-title.component.html',
  styleUrls: ['./page-title.component.scss']
})
export class PageTitleComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
